import { getI18n } from 'react-i18next';
import { showErrorNotification } from '../../actions/notifications';
import { unauthorizedAccess } from '../../actions/authentication';
import { createCountryErrorMessage } from './CountryErrors';
import { createMemberErrorMessage } from './MemberErrors';
import { createUserErrorMessage } from './UserErrors';
import { createCurrencyErrorMessage } from './CurrencyErrors';
import { createAuctionErrorMessage } from './AuctionErrors';
import { createBidErrorMessage } from './BidErrors';
import { createMessageErrorMessage } from './MessageErrors';
import {
    createMiscErrorMessage,
    ERROR_EXTRA_CONFIRMATION_NEEDED,
    ERROR_FOUR_EYES_PRINCIPLE_CREDENTIALS_NEEDED,
} from './MiscErrors';
import { createProductErrorMessage } from './ProductErrors';
import { createClearingHouseErrorMessage } from './ClearingHouseErrors';
import { createZoneErrorMessage } from './ZoneErrors';
import { createAuctioneerDataTemplateErrorMessage } from './AuctioneerDataTemplateErrors';
import { createManualCashLimitErrorMessage } from './ManualCashLimitErrors';
import { createAuctionLimitErrorMessage } from './AuctionLimitErrors';
import { createAuctioneerDataMatrixErrorMessage } from './AuctioneerDataMatrixErrors';
import { createRequestRateLimitErrorMessage } from './RequestRateLimitErrors';
import { createClientApplicationErrorMessage } from './ClientApplicationErrors';
import { createHolidayErrorMessage } from './HolidayErrors';
import { createAuctionTemplateErrorMessage } from './AuctionTemplateErrors';
import { createReportErrorMessage } from './ReportErrors';
import { createUploadErrorMessage } from './UploadErrors';
import { createUserConfigurationErrorMessage } from './UserConfigurationErrors';
import { createCashLimitErrorMessage } from './CashLimitErrors';
import { createCashLimitUploadEventErrorMessage } from './CashLimitUploadEventErrors';
import { createPasswordErrorMessage } from './PasswordErrors';
import { create2FAErrorMessage } from './TwoFAErrors';
import { createFatalErrorMessage } from './FatalError';
import { createPasswordResetTokenInvalidMessage } from './PasswordResetErrorMessage';

export const createErrorMessages = (error) => {
    const i18n = getI18n();
    let errorMessages = [];
    const { graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length > 0) {
        graphQLErrors.forEach((graphQLError) => {
            graphQLError.extensions && graphQLError.extensions.errors.forEach((err) => {
                if (err.code !== ERROR_FOUR_EYES_PRINCIPLE_CREDENTIALS_NEEDED && err.code !== ERROR_EXTRA_CONFIRMATION_NEEDED) {
                    errorMessages.push(createErrorMessage(err.code, err.params));
                }
            });
        });
    } else {
        errorMessages = [i18n.t('misc.unknown-error', { message: error.message })];
    }
    return errorMessages;
};

export const createErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    const i18n = getI18n();
    return createAuctionErrorMessage(code, params)
        || createAuctionLimitErrorMessage(code, params)
        || createAuctionTemplateErrorMessage(code, params)
        || createAuctioneerDataMatrixErrorMessage(code, params)
        || createAuctioneerDataTemplateErrorMessage(code, params)
        || createBidErrorMessage(code, params)
        || createMessageErrorMessage(code, params)
        || createCashLimitErrorMessage(code, params)
        || createCashLimitUploadEventErrorMessage(code, params)
        || createPasswordErrorMessage(code, params)
        || createClearingHouseErrorMessage(code, params)
        || createClientApplicationErrorMessage(code, params)
        || createCountryErrorMessage(code, params)
        || createCurrencyErrorMessage(code, params)
        || createHolidayErrorMessage(code, params)
        || createManualCashLimitErrorMessage(code, params)
        || createMemberErrorMessage(code, params)
        || createProductErrorMessage(code, params)
        || createReportErrorMessage(code, params)
        || createRequestRateLimitErrorMessage(code, params)
        || createUploadErrorMessage(code, params)
        || createUserConfigurationErrorMessage(code, params)
        || createUserErrorMessage(code, params)
        || createZoneErrorMessage(code, params)
        || createMiscErrorMessage(code, params)
        || create2FAErrorMessage(code, params)
        || createPasswordResetTokenInvalidMessage(code, params)
        || createFatalErrorMessage(code, params)
        || i18n.t('misc.unknown-error-code', { code, params });
};

export const createOnErrorHandler = (dispatch, apolloClient, baseErrorMessage) => (error) => {
    const i18n = getI18n();
    const { networkError } = error;
    const isUnauthorized = networkError && (networkError.statusCode === 401 || networkError.statusCode === 403);
    if (isUnauthorized) {
        dispatch(unauthorizedAccess(i18n.t('logout.unauthorized-access'), apolloClient));
    } else {
        const messageFormatter = (message) => (baseErrorMessage ? `${baseErrorMessage} ${message}` : message);
        createErrorMessages(error).forEach((errorMessage) => dispatch(showErrorNotification(messageFormatter(errorMessage))));
    }
};
